// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  or: 'ou',
  return: {
    text: 'Voltar ao início',
    title: 'Clique aqui para cancelar e voltar ao início',
  },
  create: {
    text: 'Criar uma conta',
    title: 'Clique aqui para cancelar e criar uma nova conta',
  },
} as ILanguage;
